import React from "react";
import {
  Typography,
  Container,
  Box,
  Grid,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

// Data structure for service sections
const serviceData = [
  {
    title: "Providing communication of scientific discoveries",
    items: [
      "Facilitation of communication of high level science between potential partners",
      "Inform policy makers of strategic scientific priorities",
      "Public speaking"
    ]
  },
  {
    title: "Strategic pathways",
    items: [
      "Pathways to translation and early diagnosis",
      "Determining research and impact priorities",
      "Directions for funding priorities",
      "Cultural changes in academic research"
    ]
  }
];

// Common styles
const styles = {
  sectionTitle: {
    fontWeight: 500,
    fontSize: "clamp(1.25rem, 3vw, 1.55rem)",
    // mb: 0.5,
    // mt: { xs: 1, md: 0 },
    pl: { xs: 4, sm: 0 },
    fontFamily: '"Times New Roman", Georgia, "Times", serif',
  },
  listItemIcon: {
    minWidth: 34,
    alignSelf: "flex-start",
    mt: 0.4,
  },
};

// Reusable component for rendering a service item
const ServiceItem = ({ text }) => (
  <ListItem
    disableGutters
    sx={{
      alignItems: "flex-start",
      py: 0.5,
    }}
  >
    <ListItemIcon sx={styles.listItemIcon}>
      <CheckIcon fontSize="small" />
    </ListItemIcon>
    <ListItemText
      primary={text}
      primaryTypographyProps={{
        variant: "body2",
        sx: { fontSize: "clamp(0.95rem, 2.2vw, 1.05rem)", lineHeight: 1.6 },
      }}
    />
  </ListItem>
);

// Reusable component for rendering a service section
const ServiceSection = ({ title, items }) => (
  <Grid item xs={12} md={6} sx={{ py: { xs: 0.5, md: 1 } }}>
    <Typography variant="h6" component="h3" sx={styles.sectionTitle}>
      {title}
    </Typography>
    <List dense sx={{ pl: { xs: 0, sm: 1 } }}>
      {items.map((item, index) => (
        <ServiceItem key={index} text={item} />
      ))}
    </List>
  </Grid>
);

const ListItems = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          // pb: { xs: 0, md: },
          // pt: { xs: 2, md: 3 },
          px: { xs: 2.5, sm: 4, md: 6 },
        }}
      >
        <Box sx={{ textAlign: "center", mb: { xs: 3, md: 4 } }}>
          <Typography
            variant="h4"
            component="h3"
            sx={{
              mb: 1,
              fontSize: "clamp(1.9rem, 3vw, 2.3rem)",
            }}
          >
            Consultancy and advisory services
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontSize: "clamp(1rem, 2.4vw, 1.1rem)",
              maxWidth: "42rem",
              mx: "auto",
              lineHeight: 1.6,
            }}
          >
            Providing a range of services arising from academic research
            expertise.
          </Typography>
        </Box>

        <Grid
          container
          spacing={{ xs: 2.5, md: 3.5 }}
          alignItems="flex-start"
        >
          {serviceData.map((section, index) => (
            <ServiceSection
              key={index}
              title={section.title}
              items={section.items}
            />
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default ListItems;